import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=ae99aa8a&scoped=true&"
import script from "./docs.vue?vue&type=script&lang=ts&"
export * from "./docs.vue?vue&type=script&lang=ts&"
import style0 from "./docs.vue?vue&type=style&index=0&id=ae99aa8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae99aa8a",
  null
  
)

export default component.exports